import { render, staticRenderFns } from "./OurService.vue?vue&type=template&id=a63fc650&lang=html&"
import script from "./OurService.vue?vue&type=script&lang=js&"
export * from "./OurService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports